<div class="dropdown-facet" [matTooltip]="(disabled && disabledTooltipText) || null">
  <button
    (menuClosed)="onDropdownClosed()"
    mat-flat-button
    small
    [matMenuTriggerFor]="customDropdownMenu"
    class="dropdown-facet-button"
    [ngClass]="{ disabled: disabled }"
  >
    {{ selectedLabel }}
    <span class="sif sif-chevron-s"></span>
  </button>
  <mat-menu #customDropdownMenu="matMenu" [class]="backdropPanelClass">
    <div class="dropdown-filter-menu">
      <ng-container
        *ngTemplateOutlet="
          itemsTemplate ? itemsTemplate : defaultItemsTemplate;
          context: { outletContext: outletContext }
        "
      ></ng-container>
    </div>
  </mat-menu>
</div>
<ng-template #defaultItemsTemplate let-outletContext="outletContext">
  <div class="content">
    <ng-container
      *ngTemplateOutlet="
        selectAllTemplate ? selectAllTemplate : defaultSelectAllTemplate;
        context: { outletContext: outletContext }
      "
    ></ng-container>
    <ul class="dropdown-menu-sublist">
      @for (item of outletContext.items; track item; let i = $index) {
      <li class="list-item">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate ? itemTemplate : defaultItemTemplate;
            context: { item: item, index: i, outletContext: outletContext }
          "
        ></ng-container>
      </li>
      }
    </ul>
    <div
      class="footer-button-wrapper"
      [matTooltip]="(isDeleteDisabled && deleteDisabledTooltipText) || null"
    >
      @if (footerButtonText) {
      <button
        mat-button
        color="tertiary"
        small
        type="button"
        class="delete-btn"
        (click)="footerButtonClickHandler()"
        [disabled]="isDeleteDisabled"
      >
        {{ footerButtonText }}
      </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #defaultItemTemplate let-item="item" let-outletContext="outletContext">
  <div [matTooltip]="(item.disabled && item.disabledTooltipText) || null">
    <mat-checkbox
      flat
      [label]="item.label"
      [value]="item.value"
      [checked]="showDisabledSelection ? item.selected : item.disabled ? false : item.selected"
      [disabled]="item.disabled ? true : null"
      (change)="outletContext.toggleSelection($event)"
      (click)="clickEvent($event)"
      noink
      #itemElements
      >{{ item.label }}</mat-checkbox
    >
  </div>
</ng-template>

<ng-template #defaultSelectAllTemplate let-outletContext="outletContext">
  <ul class="dropdown-menu-list">
    <li class="list-item selectAll">
      <mat-checkbox
        id="selectAll"
        flat
        (change)="outletContext.selectAll(selectAllElement.checked)"
        (click)="clickEvent($event)"
        [checked]="outletContext.allSelected"
        #selectAllElement
        >Apply to All</mat-checkbox
      >
    </li>
  </ul>
</ng-template>
